import { render, staticRenderFns } from "./zl.vue?vue&type=template&id=2ca721de&scoped=true"
import script from "./zl.vue?vue&type=script&lang=js"
export * from "./zl.vue?vue&type=script&lang=js"
import style0 from "./zl.vue?vue&type=style&index=0&id=2ca721de&prod&lang=scss&scoped=true"
import style1 from "./zl.vue?vue&type=style&index=1&id=2ca721de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca721de",
  null
  
)

export default component.exports